module.exports = __webpack_public_path__ + "static/media/esen-screenshot.3d4c50fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/esen-screenshot.jpg
// module id = 572
// module chunks = 0